{
    "DatePattern": "TT-MMM-JJJJ",
    "NAME": "Date"
}